import React from "react";

import { ValidationPriority } from "@lib/store/src/ui/hooks/timeslots/useDaySchedule";
import { cn, pxToRem } from "@utils";
import { Icon } from "@atoms";

interface ValidationMessageProps {
  message: string;
  priority?: ValidationPriority;
}

export const WarningIndicator: React.FC<ValidationMessageProps> = ({ message, priority = ValidationPriority.Low }) => {
  const isHigh = priority === ValidationPriority.High;

  return (
    <div
      className={cn("flex flex-row items-start gap-4 p-4 rounded-md", {
        "bg-functional-red/50": isHigh,
        "bg-functional-orange/[0.15]": !isHigh,
      })}>
      <div
        className={cn("flex items-center justify-center mt-1 size-4 rounded-full", {
          "bg-functional-red": isHigh,
          "bg-functional-orange": !isHigh,
        })}>
        <Icon
          icon={isHigh ? "plus" : "warning"}
          size={pxToRem(13)}
          className={cn("text-white")}
          color="currentColor"
          style={isHigh ? { transform: "rotate(45deg)" } : {}}
        />
      </div>

      <div className="flex-1 mt-0.5">
        <p>{message}</p>
      </div>
    </div>
  );
};
